import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";
import useActive from "../../hooks/useActive";
// import productsData from '../../data/productsData';
import ProductCard from "./ProductCard";
import commonContext from "../../contexts/common/commonContext";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import filtersContext from "../../contexts/filters/filtersContext";

const TopProducts = () => {
  const { productsData, productsLoading, fetchProducts } =
    useContext(commonContext);
  const [products, setProducts] = useState([]);
  const { activeClass, handleActive } = useActive(0);

  useEffect(() => {
    fetchProducts();
  }, []);

  useEffect(() => {
    if (productsData) {
      setProducts(productsData);
    }
  }, [productsData]);
  const productsCategory = [
    "Wszystkie",
    ...new Set(productsData.map((item) => item.category)),
  ];

  const handleProducts = (category, i) => {
    if (category === "Wszystkie") {
      setProducts(productsData);
      handleActive(i);
      return;
    }

    const filteredProducts = productsData.filter(
      (item) => item.category === category
    );
    setProducts(filteredProducts);
    handleActive(i);
  };

  return (
    <>
      {!products?.length && productsLoading ? (
        <div className="loader-container">
          <Box sx={{ display: "flex" }}>
            <CircularProgress
              size={60}
              sx={{
                color: "#FF0000", // Custom color
              }}
            />
          </Box>
        </div>
      ) : (
        <>
          <div className="products_filter_tabs">
            <ul className="tabs">
              {productsCategory.map((item, i) => (
                <li
                  key={i}
                  className={`tabs_item ${activeClass(i)}`}
                  onClick={() => handleProducts(item, i)}
                >
                  {item.charAt(0).toUpperCase() + item.slice(1)}
                </li>
              ))}
            </ul>
          </div>
          <div className="wrapper products_wrapper">
            {products.slice(0, 11).map((item) => (
              <ProductCard key={item.id} {...item} />
            ))}
            <div className="card products_card browse_card">
              <Link to="/all-products">
                Wybierz wszystkie <br /> produkty <BsArrowRight />
              </Link>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default TopProducts;
